import { Button, Space } from "antd"
import { MerchantStatusData } from "../../../domain/invoicing/rainforest"
import SimulateSandboxEventModal from "./SimulateSandboxEventModal"
import { useState } from "react"

type Props = {
  merchantStatusData: MerchantStatusData
}

const SandboxActions = ({merchantStatusData}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  
  if (!merchantStatusData.isSandbox) {
    return null
  }

  return <Space>
    <Button onClick={() => setIsModalOpen(true)}>Simulate Event</Button>
    <SimulateSandboxEventModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
  </Space>
}

export default SandboxActions